import { CardSkeleton } from '@/components/layout/card-skeleton'

export const HomeFallback = () => {
  return <CardSkeleton />
}
